module.exports = __webpack_public_path__ + "static/media/1017095.94b3cd2e.png";